export default __webpack_public_path__ + "static/media/PSP2.15875c57.png";